import { jsx } from "panel";
import { ModalEl } from "common/components/modal";
import { ButtonTheme } from "common/components/button/constants";
import { ButtonEl } from "common/components/button";
import { SpinnerEl } from "common/components/spinner";
import { SpinnerSize } from "common/components/spinner/types";
export function template() {
  return /* @__PURE__ */ jsx(ModalEl, {
    sel: "#media-modal",
    attrs: {
      open: this.state.isModalOpen,
      closeable: true,
      "modal-title": `Watch Tutorial`,
      "grow-to-content": true
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".modal-container"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".modal-title"
  }, "Watch Tutorial"), /* @__PURE__ */ jsx("div", {
    sel: ".modal-content"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".video-container"
  }, /* @__PURE__ */ jsx(SpinnerEl, {
    sel: "#tutorial-spinner",
    attrs: { size: SpinnerSize.Large }
  }), /* @__PURE__ */ jsx("iframe", {
    sel: "#tutorial-iframe",
    attrs: { src: `https://www.youtube.com/embed/PbKnQ777vuk`, width: 560, height: 315, allowfullscreen: true }
  })), /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".done-button",
    attrs: {
      theme: ButtonTheme.Primary
    },
    on: {
      click: () => this.helpers.closeModalHandler()
    }
  }, "Done")))));
}
